import axios from 'axios';
import { defineStore } from 'pinia';

interface Insurer {
  id: number;
  org_id?: string;
  name: string;
  code: string;
  email: string;
  currency: string;
  country?: string;
  country_iso_code?: string;
  allow_repair_estimates: boolean;
  agent_vehicle_form_enabled: boolean;
  third_party_policy_enabled?: boolean;
  pay_public_key?: string;
  logo?: string;
  claim_verification_required?: boolean;
  required_license_plate_enabled?: boolean;
  fleet_vehicle_information_enabled?: boolean;
  policy_approval_enabled?: boolean;
  claim_information_capture_mode?:
    | 'admin_triggered_claim_form_link'
    | 'immediate_after_inspection';
  claims_assessment_validation_method: 'all' | 'policy_number' | 'licence_plate';
  preference?: Preference;
}

interface Preference {
  id: number;
  location_coordinates_required?: boolean;
  assessment_redirect_url: string;
  mobile_app_modules_enabled: 'all' | 'agents' | 'customers';
  customer_modules_enabled?: Array<string>;
  agent_email_domain: string | null;
}

const Axios = axios.create({
  baseURL: import.meta.env.VITE_APP_API_URL,
  headers: { 'Content-Type': 'application/json' },
});

export const useInsurerStore = defineStore('insurer', {
  state: (): {
    insurer: Insurer | null;
    vehicleBrands: Array<{
      id: number;
      name: string;
      countries?: Array<string>;
    }>;
  } => ({ insurer: null, vehicleBrands: [] }),
  getters: {
    getInsurer: (state) => state.insurer,
    getVehicleBrands: (state) => state.vehicleBrands,
  },
  actions: {
    async setInsurer(code: string, params?: any) {
      const response = await Axios.get(`/insurer/${code}`, { params });
      this.insurer = response.data.data;
      return response;
    },
    setVehicleBrands(
      brands: Array<{ id: number; name: string; countries: Array<string> }>,
    ) {
      this.vehicleBrands = brands;
    },
  },
});
